const types = {
    SESSION_SET_APP_READY: 'SESSION_SET_APP_READY',
    SESSION_SET_CAPTIONS_LOADED: 'SESSION_SET_CAPTIONS_LOADED',
    SESSION_SET_LANGUAGE: 'SESSION_SET_LANGUAGE',
    SESSION_SET_REQUEST_PARAMETER_IDS: 'SESSION_SET_REQUEST_PARAMETER_IDS',
};

const sessionActions = {
    types,

    /**
     * @param {object} parameterIds
     * @returns {{type: string, parameterIds: object}}
     */
    setRequestParameterIds(parameterIds) {
        return { type: types.SESSION_SET_REQUEST_PARAMETER_IDS, parameterIds };
    },

    /**
     * @returns {{type: string}}
     */
    setAppReady() {
        return { type: types.SESSION_SET_APP_READY };
    },

    setCaptionsLoaded() {
        return { type: types.SESSION_SET_CAPTIONS_LOADED };
    },

    setLanguage(language) {
        return { type: types.SESSION_SET_LANGUAGE, language };
    },
};

export default sessionActions;



/** WEBPACK FOOTER **
 ** ./src/actions/SessionActions.js
 **/